import { Factory } from '../Factory';
import { Service } from '../Service';

namespace app.services.collections {

  export class ReviewService extends Service<any> {
    private configService: app.services.IConfigService;
    private httpService: app.services.IHttpWrapperService;

    constructor(resource: any, rootScope: IRootScope, httpService: app.services.IHttpWrapperService, configService: app.services.IConfigService, resourceWrapperService: ResourceWrapperService) {
      super({resource, rootScope, resourceWrapperService});

      this.httpService = httpService;
      this.configService = configService;

      let projectBillingResource = this.resource(`${configService.getServerBaseUrlForResource()}/review/:id`,
        {id: '@id'}
      );

      this.itemResource = this.resourceWrapperService.WrapActions(projectBillingResource);
    }

    public async GetReviewStatistics(projectId: string) {
      let url = `${this.configService.getServerBaseUrl()}/review/${projectId}`;

      const response = await this.httpService.$http({
        method: 'GET',
        url: url
      });

      return response.data;
    }

  }

  frontendApp.factory("ReviewService", ['$resource', '$rootScope', 'HttpService', 'ConfigService', 'ResourceWrapperService', function(resource, rootScope, httpService, configService, resourceWrapperService) {
    return new ReviewService(resource, rootScope, httpService, configService, resourceWrapperService);
  }]);
}
